module.exports = __webpack_public_path__ + "img/search.174df740.svg";